<template>  
  <div class="page-404-container">
    <fifty-fifty :schema="schema"></fifty-fifty>
  </div>
</template>

<script>
import FiftyFifty from '@/scripts/components/sections/FiftyFifty.vue'

export default {
  name: 'Page404',
  components: { FiftyFifty },
  props: {
    schema: Object
  }
}
</script>

<style scoped lang="scss">
  /deep/ .ff__body,
  /deep/ .ff__body p {
    line-height: 1.375rem;
    margin-bottom: 16px;
  }

  /deep/ .ff__main-wrap {
    @include mobile-only {
      text-align: center;
      max-width: 100%;
    }
  }

  /deep/ .sw {
    max-width: 100%;
    padding: 40px 0;
    @include mobile-tablet {
      padding: 0;
    }

    &__main-image-content-container {

      @include tablet-up {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }

</style>
